import { useEffect, useRef, useState } from 'react';

export const useDragScroll = (scrollRef: React.RefObject<HTMLElement>) => {
    const [isDragging, setIsDragging] = useState(false);
    const startX = useRef(0);
    const startY = useRef(0);
    const scrollLeft = useRef(0);
    const scrollTop = useRef(0);

    useEffect(() => {
        const scrollElement = scrollRef.current;

        if (!scrollElement) return;

        const handleMouseDown = (e: MouseEvent) => {
            setIsDragging(true);
            startX.current = e.pageX - scrollElement.offsetLeft;
            startY.current = e.pageY - scrollElement.offsetTop;
            scrollLeft.current = scrollElement.scrollLeft;
            scrollTop.current = scrollElement.scrollTop;
            scrollElement.style.cursor = 'grabbing';
            e.preventDefault();
        };

        const handleMouseMove = (e: MouseEvent) => {
            if (!isDragging) return;

            const x = e.pageX - scrollElement.offsetLeft;
            const y = e.pageY - scrollElement.offsetTop;

            const walkX = (x - startX.current) * 1.5;
            const walkY = (y - startY.current) * 1.5;

            scrollElement.scrollLeft = scrollLeft.current - walkX;
            scrollElement.scrollTop = scrollTop.current - walkY;
        };

        const handleMouseUp = () => {
            setIsDragging(false);
            if (scrollElement) scrollElement.style.cursor = 'grab';
        };

        scrollElement.addEventListener('mousedown', handleMouseDown);
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);

        return () => {
            scrollElement.removeEventListener('mousedown', handleMouseDown);
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [scrollRef, isDragging]);
};
